export default __webpack_public_path__ + "static/media/Legguards of the Wicked.93a71fb0.jpg";